// extracted by mini-css-extract-plugin
export var typingIndicator = "_qt-0";